import Enlang from './entries/en-US';
import Vilang from './entries/vi-VN';

const AppLocale = {
  en: Enlang,
  vi: Vilang,
};

export default AppLocale;
